module.exports = __webpack_public_path__ + "static/media/marcelo_pereira.538f0ec0.jpg";